// @flow

import React from 'react';
import { bind } from '@ta/common.api';
import ProfileDataCell, { type MemberData } from './ProfileDataCell';
import ProfileSubLinks from './ProfileSubLinks';

type ExternalProps = {|
  /** If there are unread messages then the inbox link should display an icon */
  displayInboxIcon: boolean,
  /** The data for this specific member */
  memberData: ?MemberData,
  /** If the user is an owner the profile section needs to display a Management section in its sub links */
  isOwner: boolean,
  /** This function is used to set Uploader Modal's modalname and pid which are used to show coresponding uploader modal  */
  setModalInfo: (name: string, pid: number) => void,
  /** This function is passed along to handle opening the Explicit Preferences onboarding flow when a member registers */
  openExplicitPreferences: boolean => boolean,
|};

type Props = {|
  ...ExternalProps,
  servletName: string,
|};

/**
 * This is the top section of the side bar menu which displays the user information (username/avatar) or login information if the user is not logged in
 * Below this it displays sub links: (Management center link if owner), My trips, Recently Viewed, Bookings, Inbox
 */
const SideBarProfile = (props: Props) => (
  <React.Fragment>
    <ProfileDataCell
      memberData={props.memberData}
      openExplicitPreferences={props.openExplicitPreferences}
    />
    <ProfileSubLinks
      displayInboxIcon={props.displayInboxIcon}
      isOwner={props.isOwner}
      setModalInfo={props.setModalInfo}
    />
  </React.Fragment>
);

/** Makes an api call to MemberEndpoint.java and passes this data into the sideBarProfile component as props */
export default bind<Props, ExternalProps, _, _, _, _>((state, stage) => {
  const { loggedInUserId, isMember } = state.auth;
  const memberApiCall = isMember ? stage(`/data/1.0/member/self?userId=${loggedInUserId}`) : null;

  return newState => {
    const response = memberApiCall ? memberApiCall.get() : {};
    const { data } = response;

    const memberData =
      data === null || typeof data === 'undefined'
        ? null
        : {
            profileUrl: data.profile,
            userName: data.name,
            avatarUrl: data.avatar,
          };

    return {
      memberData,
      isOwner: data ? data.isOwner : false,
      servletName: newState.meta.initialServletName,
    };
  };
})(SideBarProfile);
